export default "### 2023-05-01 - Portal v4.2.23\n---\n\nFeatures\n- Stability & Performance Improvements\n\n\nBugs Fixed\n- dcp-config handling fixes\n\n"